<template>
    <div class="white-bg down-auto">
        <h2 class="side-title">猜你喜欢</h2>
        <ul>

            <li><a target="_blank" href="html/96.html"><i><img src="../../assets/images/ex07.png"></i>
                <p>腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/91.html"><i><img
                    src="http://menhu.yangqq.com/d/file/p/2019/05-04/77858802ef0b011a8066feb4fa6048f1.jpg"></i>
                <p>营销qq2019最新版 v2.21.2927 官方版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/94.html"><i><img src="../../assets/images/ex05.png"></i>
                <p>Smart QQ下载 2.0 官方版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/16.html"><i><img src="../../assets/images/ex01.png"></i>
                <p>腾讯QQ下载v9.1.1.24953 最新版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/92.html"><i><img src="../../assets/images/ex03.png"></i>
                <p>Wine QQ国际版 UbuntuKylin版 官方版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/90.html"><i><img src="../../assets/images/ex02.png"></i>
                <p>腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/93.html"><i><img src="../../assets/images/ex04.png"></i>
                <p>企业QQ2019电脑版 v2.0 最新版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/95.html"><i><img src="../../assets/images/ex06.png"></i>
                <p>腾讯QQ下载v9.1.1.24953 最新版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/97.html"><i><img src="../../assets/images/ex08.png"></i>
                <p>营销qq2019最新版 v2.21.2927 官方版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>

            <li><a target="_blank" href="html/98.html"><i><img src="../../assets/images/ex09.png"></i>
                <p>hbuilder v9.1.29官网版</p>
                <span class="down-info">大小：<em>261M</em></span></a></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Liked"
    }
</script>

<style scoped>

</style>